import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthWithBoxSignUp() {
	return <AuthShell variant="with-box"><AuthForm variant="with-box" mode="sign-up" /></AuthShell>;
}

export default AuthWithBoxSignUp;
